import { Volume2, VolumeX } from "lucide-react";
import { useAudio } from "@/context/AudioContext";
import { cn } from "@/lib/utils";

export const SoundToggle = ({ className, withLabel = false }) => {
  const { enabled, toggle } = useAudio();
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="global-nav-sound-toggle"
      aria-pressed={enabled}
      aria-label={enabled ? "Mute brand sound" : "Play brand sound"}
      className={cn(
        "group inline-flex items-center gap-2 rounded-full border px-3 py-2 text-[11px] font-medium uppercase tracking-[0.14em] transition-colors",
        enabled
          ? "border-[color:var(--bp-teal)] text-[color:var(--bp-teal)]"
          : "border-[color:var(--bp-border)] text-[color:var(--bp-text-muted)] hover:border-[color:var(--bp-teal)] hover:text-[color:var(--bp-teal)]",
        className
      )}
    >
      {enabled ? <Volume2 className="h-4 w-4" /> : <VolumeX className="h-4 w-4" />}
      {withLabel && <span>{enabled ? "Sound on" : "Sound off"}</span>}
      {enabled && (
        <span className="flex h-3 items-end gap-[2px]" aria-hidden>
          <span className="w-[2px] animate-[eq_0.9s_ease-in-out_infinite] bg-[color:var(--bp-teal)]" style={{ height: "60%" }} />
          <span className="w-[2px] animate-[eq_0.9s_ease-in-out_infinite_0.2s] bg-[color:var(--bp-teal)]" style={{ height: "100%" }} />
          <span className="w-[2px] animate-[eq_0.9s_ease-in-out_infinite_0.4s] bg-[color:var(--bp-teal)]" style={{ height: "40%" }} />
        </span>
      )}
      <style>{`@keyframes eq{0%,100%{transform:scaleY(0.4)}50%{transform:scaleY(1)}}`}</style>
    </button>
  );
};
